import React from 'react';
import { ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import WithErrorDialog from '../../components/ErrorModal/WithErrorDialog';
import { withContext } from '../../context/appContext';
import theme from '../../styles/theme';
import Footer from './Footer';
import Header from './Header';

const Layout = ({
  children,
}) => (
  <ThemeProvider theme={theme}>
    <Header />
    <main>
      {children}
    </main>
    <Footer />
  </ThemeProvider>
);

Layout.propTypes = {
  children: PropTypes.shape(),
};

Layout.defaultProps = {
  children: undefined,
};

export default withContext()(WithErrorDialog(Layout));
